import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";
import { DevLogin } from "@/components/DevLogin";

interface DevAuthContextProps {
  isAuthenticated: boolean;
  logout: () => void;
}

const DevAuthContext = createContext<DevAuthContextProps | undefined>(
  undefined
);

export const useDevAuth = () => {
  const context = useContext(DevAuthContext);
  if (context === undefined) {
    throw new Error("useDevAuth must be used within a DevAuthProvider");
  }
  return context;
};

interface DevAuthProviderProps {
  children: ReactNode;
}

export const DevAuthProvider: React.FC<DevAuthProviderProps> = ({
  children,
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const hostname = window.location.hostname;

    // Development ortamı kontrolü - sadece development subdomain ve localhost için
    const isDevelopment =
      hostname.includes("development") || hostname.startsWith("dev.");

    // Development ortamı değilse direkt geç
    if (!isDevelopment) {
      setIsAuthenticated(true);
      setIsLoading(false);
      return;
    }

    // Development ortamı için auth kontrolü
    const savedAuth = localStorage.getItem("harmony_dev_auth");
    if (savedAuth === "authenticated") {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const login = () => {
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem("harmony_dev_auth");
    setIsAuthenticated(false);
  };

  // Loading state
  if (isLoading) {
    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Development domain'i değilse veya oturum açıksa doğrudan içeriği göster
  // if (!isAuthenticated) {
  return (
    <DevAuthContext.Provider value={{ isAuthenticated, logout }}>
      {children}
    </DevAuthContext.Provider>
  );
  // }

  // Development domain'indeyse ve giriş yapılmamışsa login ekranı göster
  return <DevLogin onLogin={login} />;
};
